:host {
    display: grid;
    grid-template-rows: repeat(var(--ux-row-count), min-content);
}